import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Checkin from './components/Checkin';
import Register from './components/Register';
import AutoMatch from './components/AutoMatch';
import PlayerManager from './components/PlayerManager';
import Monitor from "./components/Monitor";
import PlayerHistory from './components/PlayerHistory';
import LineAuth from './components/LineAuth';
import RankTable from './components/RankTable';
import JoinCheckin from './components/JoinCheckin';
import QrCheckinLogin from './components/QrCheckinLogin';
import GroupMatchAdmin from './components/GroupMatchAdmin';
import SystemAdmin from './components/SystemAdmin';
import Reward from './components/Reward';
import AdminRewards from './components/AdminRewards';
import MatchPlanner from './components/MatchPlanner';
import MatchRequest from './components/MatchRequest';
import AdminResultLog from './components/AdminResultLog';
import AdminQrPage from './components/AdminQrPage';
import AdminSidebar from './components/AdminSidebar';
import GameMatchControlPage from './components/GameMatchControlPage';
import AdminCheckinPage from './components/AdminCheckinPage';
import LineBrowserGuard from './components/LineBrowserGuard';
import InstallShortcut from './components/InstallShortcut';
import AdminPlayerEditModal from './components/AdminPlayerEditModal';
import SystemMonitor from './components/SystemMonitor';
import AdminLineLink from './components/AdminLineLink';
import './css/tokens.css';
import './css/layout.css';
import './css/ResponsiveFixes.css';
import './css/admin-alerts.css';
import './css/typography.css';

/* ================= AUTO MATCH ================= */

function AutoMatchWrapper() {
  const { groupId } = useParams();
  return <main className="admin-shell-with-sidebar"><AdminSidebar active="planner" groupId={Number(groupId)} /><AutoMatch groupId={Number(groupId)} /></main>;
}

/* ================= PLAYER MANAGER ================= */

function PlayerManagerWrapper() {
  const { groupId } = useParams();
  return <main className="admin-shell-with-sidebar"><AdminSidebar active="users" groupId={Number(groupId)} /><PlayerManager groupId={Number(groupId)} /></main>;
}

/* ================= APP ================= */

function App() {
  return (
    <Router>
      <LineBrowserGuard />
      <InstallShortcut />
      <AdminPlayerEditModal />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/profile" element={<PlayerHistory profileMode />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/checkin" element={<Checkin />} />
        <Route path="/join/:groupId" element={<JoinCheckin />} />
        <Route path="/join/:groupId/login" element={<QrCheckinLogin />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/monitor" element={<Monitor />} />
        <Route path="/monitor/:groupId" element={<Monitor />} />
        <Route path="/player-history/:groupId/:userId" element={<PlayerHistory />} />
        <Route path="/line-auth" element={<LineAuth />} />
        <Route path="/gameauto/:groupId" element={<AutoMatchWrapper />} />
        <Route path="/players/:groupId" element={<PlayerManagerWrapper />} />
        <Route path="/admin_monitor" element={<SystemMonitor />} />
        <Route path="/admin_monitor/:groupId" element={<SystemMonitor />} />
        <Route path="/admin/group/:groupId/matches" element={<GroupMatchAdmin />} />
        <Route path="/admin/users" element={<SystemAdmin />} />
        <Route path="/admin/line-links" element={<AdminLineLink />} />
        <Route path="/rewards" element={<Reward />} />
        <Route path="/admin/rewards" element={<AdminRewards />} />
        <Route path="/admin/result-logs" element={<AdminResultLog />} />
        <Route path="/admin/checkin-qr" element={<AdminQrPage mode="checkin" />} />
        <Route path="/admin/monitor-qr" element={<AdminQrPage mode="monitor" />} />
        <Route path="/admin/checkin/:groupId" element={<AdminCheckinPage />} />
        <Route path="/match-planner/:groupId" element={<MatchPlanner />} />
        <Route path="/game-match-control/:groupId" element={<GameMatchControlPage />} />
        <Route path="/match-request" element={<MatchRequest />} />
<Route
  path="/rank"
  element={<RankTable />}
/>
      </Routes>
    </Router>
  );
}

export default App;
